"use client";

import Image from "next/image";
import { g2Badges } from "@/lib/g2-badges";

export function BadgeMarquee() {
  // Duplicate so CSS marquee has seamless loop
  const badges = [...g2Badges, ...g2Badges];

  return (
    <div className="relative overflow-hidden py-6">
      <div
        className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24"
        style={{
          background: "linear-gradient(to right, var(--background), transparent)",
        }}
        aria-hidden
      />
      <div
        className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24"
        style={{
          background: "linear-gradient(to left, var(--background), transparent)",
        }}
        aria-hidden
      />

      <div className="marquee-track flex gap-3">
        {badges.map((b, i) => (
          <div
            key={i}
            className="flex h-20 w-20 flex-shrink-0 items-center justify-center rounded-lg bg-white p-1.5"
            title={`${b.badgeType} · ${b.segment}`}
          >
            <Image
              src={`/logos/g2/${b.filename}`}
              alt={b.badgeType}
              width={64}
              height={64}
              className="h-full w-full object-contain"
            />
          </div>
        ))}
      </div>

      <style>{`
        .marquee-track {
          animation: marquee 60s linear infinite;
          width: max-content;
        }
        .marquee-track:hover {
          animation-play-state: paused;
        }
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee-track { animation: none; }
        }
      `}</style>
    </div>
  );
}
